import styles from './ReportTable.module.css';

export const isVisibleOptions = {
  root: document.getElementById('report_box'),
  rootMargin: '200px 0px 10px 0px',
  threshold: 0,
};
export const getRowHeight = (row, isGroupedRow = false) => {
  let isAgg =
    !isGroupedRow &&
    row
      .getVisibleCells()
      .find((cell) => !cell.column.getIsGrouped())
      .getIsAggregated();

  return isGroupedRow
    ? row.groupingColumnId === 'category'
      ? 50
      : 42
    : isAgg && row.groupingColumnId !== 'expense_code'
    ? 48
    : 30;
};

export const getGroupingRowKey = (row, index, isGroupStart = false) => {
  return `${row.id}_group${index ? '_' + index : ''}${
    isGroupStart ? '_begin' : ''
  }`;
};
export const getLeafRowKey = (row, index, isGroupEnd = false) => {
  return `${row.id}${index ? '_' + index : ''}_leaf${
    isGroupEnd ? '_grouping_end' : ''
  }`;
};
export const getGroupingRowClassname = (row) => {
  return row.groupingColumnId === 'category'
    ? row.original.category === 'EXPENSE'
      ? styles.core_header_orange
      : styles.core_header_blue
    : row.groupingColumnId === 'activity'
    ? styles.activity_header
    : row.groupingColumnId === 'abr'
    ? styles.abr_header
    : row.groupingColumnId === 'expense_code'
    ? styles.abr_code
    : '';
};
export const getCellKey = (cell, grouping = 'NONE') => {
  let isGroupHeader = grouping === 'HEADER';
  let isGroupStart = grouping === 'BEGIN';
  let isGroupEnd = grouping === 'END';
  return `${cell.id}${isGroupHeader ? '_group_header' : ''}${
    isGroupStart ? '_group_begin' : ''
  }${isGroupEnd ? '_grouping_end' : ''}`;
};
export const getCellClassname = (row, cell, index) => {
  return `${cell.column.columnDef.moneyCell ? styles.money_cell + ' ' : ''}${
    cell.getIsAggregated() && row.groupingColumnId !== 'expense_code'
      ? styles.agg_cell + ' '
      : ''
  }${
    row.groupingColumnId === 'category' && cell.getIsAggregated()
      ? styles.core_category_total + ' '
      : ''
  }${
    row.groupingColumnId === 'org_id' && cell.getIsAggregated()
      ? styles.core_total + ' '
      : ''
  }${!cell.getIsAggregated() ? styles.detail_cell + ' ' : ''}${
    index && index % 2 !== 0 ? styles.detail_cell_gray : styles.detail_cell
  }${cell.column.columnDef.id === 'expense_code' ? ' ' + styles.abr_code : ''}`;
};
